export default [
    {
       key: 'total',
       label: 'รวม',
    },
    {
       key: 'to_day',
       label: 'วันนี้',
       thClass: 'text-dark bg-primary',
       variant: 'primary'
    },
    {
       key: 'yesterday',
       label: 'เมื่อวาน'
    },
    {
       key: 'two_days_ago',
       label: '2 วันที่แล้ว'
    },
    {
       key: 'three_days_ago',
       label: '3 วันที่แล้ว'
    },
    {
       key: 'more_than_four_days',
       label: '4 วันขึ้นไป'
    },
]